// View models for the device-type/device metrics comparison popup.
// originId is the template group/metric's own PK (metricGroupId/metricId from the
// pending-config draft) - nullable only for rows with no template counterpart
// (manually-created or legacy pre-migration rows).

export enum MetricSyncStatusEnum {
  SYNCED = 'SYNCED',       // same origin id, identical config -> full moon
  CONFLICT = 'CONFLICT',   // same origin id, config differs -> half moon
  NONE = 'NONE'            // no matching origin id -> dash
}

export enum CompareActionEnum {
  ADD = 'ADD',
  REPLACE = 'REPLACE',
  DISABLED = 'DISABLED'
}

export interface CompareMetricVM {
  id: number;
  originId?: number | null;
  name: string;
  dataUnitId?: number;
  divider?: number;
  decimalDigits?: number;
  transportConfiguration?: any;
  selected?: boolean;

  // Client-side identity carried through from the underlying draft row for rows that
  // don't have a real backend `id` yet - see src/app/utils/rowKey.ts.
  _uiKey?: string;

  // Populated only for template(left)-side rows, computed against the currently
  // selected device(right)-side group.
  syncStatus?: MetricSyncStatusEnum;
  action?: CompareActionEnum;
  matchedDeviceMetric?: CompareMetricVM;
}

export interface CompareGroupVM {
  id: number;
  originId?: number | null;
  name: string;
  transportConfiguration?: any;
  isWritableOnEdge?: boolean;
  metrics: CompareMetricVM[];

  // Client-side identity carried through from the underlying draft row for rows that
  // don't have a real backend `id` yet - see src/app/utils/rowKey.ts.
  _uiKey?: string;

  // Populated only for template(left)-side rows.
  action?: CompareActionEnum;
  matchedDeviceGroup?: CompareGroupVM;
}
